// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cKXJw4 {
  padding: 8px 12px 0;
}
.Z1csWR {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--sidebar-item-text, #fff);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  cursor: pointer;
}
.Z1csWR svg {
  flex-shrink: 0;
}
.Z1csWR:hover {
  background: rgba(255, 255, 255, 0.1);
}
.Z1csWR:disabled {
  opacity: 0.6;
  cursor: wait;
}
.Z1csWR:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -2px;
}
.m88zma {
  display: block;
  padding: 8px 12px;
  color: var(--sidebar-item-text, #fff);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Bpo/BpoReturnButton.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;AACjB","sourcesContent":[".container {\n  padding: 8px 12px 0;\n}\n.button {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 12px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--sidebar-item-text, #fff);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  text-align: left;\n  cursor: pointer;\n}\n.button svg {\n  flex-shrink: 0;\n}\n.button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.button:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n.button:focus-visible {\n  outline: 2px solid currentColor;\n  outline-offset: -2px;\n}\n.error {\n  display: block;\n  padding: 8px 12px;\n  color: var(--sidebar-item-text, #fff);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cKXJw4`,
	"button": `Z1csWR`,
	"error": `m88zma`
};
module.exports = ___CSS_LOADER_EXPORT___;
